import { isBrowser } from '../environment';
import svtDataSdkClient from '../../../client/dataLake';
import { impressionEventBatch, impressionEventPart, listTrackingEvent } from './customEvents';
import { ListTracking } from '../contentoUtils';

export type ImpressionEvent = {
    listId: string;
    listType: string;
    listItemIndex: number;
    listIndex: number;
    listExpandedState: boolean;
    contentId: string;
    dateTime: string;
};

const IMPRESSIONS_SEND_INTERVAL = 10000;
const impressionsToSend: Array<ImpressionEvent> = [];

const waitForAbiskoSetup = isBrowser()
    ? require('../../../client/abisko').waitForAbiskoSetup // eslint-disable-line
    : Promise.resolve();

const setOrvestoData = (orvestoData: string): void => {
    const orvestoLib = isBrowser() && window._cInfo; // eslint-disable-line
    if (orvestoLib && document.cookie.match('__codnt') === null) {
        orvestoLib.push({ cmd: '_trackContentPath', val: orvestoData }, { cmd: '_executeTracking' });
    }
};

export const sendOrvestoStatistics = (orvestoData: string): void => {
    if (orvestoData) {
        setOrvestoData(orvestoData);
    }
};

type DataLake = {
    content: {
        id: string;
        type?: string;
    };
};

type ViewEvent = {
    content?: {
        id: string;
    };
    product?: {
        viewId: string;
        viewType: string;
    };
};

const DEFAULT_DATA_LAKE: DataLake = {
    content: {
        id: undefined,
        type: undefined,
    },
};

const trackImpressions = (): void => {
    if (impressionsToSend.length > 0) {
        const batchedImpressions = impressionEventBatch([...impressionsToSend]);
        impressionsToSend.length = 0;
        svtDataSdkClient.trackNonInteractiveEvent(batchedImpressions);
    }
};

export const trackViewEvent = (data: ViewEvent = {}): void => {
    waitForAbiskoSetup.then(() => {
        trackImpressions();
        svtDataSdkClient.trackViewEvent({ ...DEFAULT_DATA_LAKE, ...data });
    });
};

// https://git.svt.se/data/web-sdk#custom-event
export const trackCustomEvent = (data = {}): void => {
    waitForAbiskoSetup.then(() => {
        svtDataSdkClient.trackCustomEvent({ ...data });
    });
};

// https://git.svt.se/data/web-sdk#custom-event
export const trackNonInteractiveEvent = (data = {}): void => {
    waitForAbiskoSetup.then(() => {
        svtDataSdkClient.trackNonInteractiveEvent({ ...data });
    });
};

export const createListTrackingOnClick =
    (listTracking: ListTracking) =>
    (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        itemPosition: number,
        svtId: string,
        leadsToPlayable = false,
        linkFromImage = false
    ): void => {
        const eventData = {
            ...listTracking,
            listItemIndex: itemPosition,
            contentId: svtId,
            leadsToPlayable,
            linkFromImage,
        };

        trackCustomEvent(listTrackingEvent(eventData, e?.currentTarget));
    };

export const createTrackingOnItemImpression =
    (listTracking: ListTracking, overrideListIndex?: number) => (element, itemPosition, svtId) => {
        const eventData = {
            ...listTracking,
            overrideListIndex,
            listItemIndex: itemPosition,
            contentId: svtId,
            dateTime: new Date().toISOString(),
        };

        impressionsToSend.push(impressionEventPart(eventData, element));
    };

setInterval(() => {
    waitForAbiskoSetup.then(() => {
        trackImpressions();
    });
}, IMPRESSIONS_SEND_INTERVAL);
